<template>
	<page gradient-background>
		<doc-base>
			<template #title>{{baseInfo.apply_user_name}}_资产归还单</template>

			<template #info>
				<c-field label="单据编号">{{baseInfo.apply_code}}</c-field>
			</template>
		</doc-base>

		<doc-content>
			<c-field label="关联领用单"><c-link @click="mp.navigateWeb('/assets/receive/detail', {id: baseInfo.receive_apply_id})">{{baseInfo.receive_apply_code}}</c-link></c-field>
			<c-field label="归还时间">{{baseInfo.return_time}}</c-field>
			<c-field label="归还资产明细" vertical>
				<detail-card v-for="(item, i) in baseInfo.item_list" :key="i" :index="i + 1">
					<template #title>
						<p>{{item.asset_name}}</p>
					</template>
					<c-field label="资产分类">{{item.asset_category || '-'}}</c-field>
					<c-field label="归还数量">{{item.return_quantity}}{{item.unit_name}}</c-field>
					<c-field label="凭证">
						<c-file-list :value="item.voucher_image_url"></c-file-list>
					</c-field>
				</detail-card>
			</c-field>
			<c-field label="备注">{{baseInfo.remark}}</c-field>
		</doc-content>

		<doc-handle
			ref="docHandle"
			:status="baseInfo.apply_status"
			:applicant="baseInfo.is_founder == 1"
			@edit="mp.navigateWeb('/assets/return/edit', {id: baseInfo.id})"
			@delete="deleteHandle"
			@update="update"
		></doc-handle>
	</page>
</template>

<script>
	export default {
		props: {
			id: String
		},

		data() {
			return {
				baseInfo: {}
			}
		},

		mounted() {
			this.update();
			
			this.$onShow(() => {
				this.update();
				this.$refs.log.update();
			});
		},

		methods: {
			update() {
				this.request({
					url: '/asset_return_apply/detail',
					data: {
						id: this.id
					},
					success: data => {
						this.baseInfo = data;
					}
				});
			},

			deleteHandle() {
				this.$confirm({
					message: '确定要删除该单据吗',
					resolve: () => {
						this.request({
							url: '/asset_return_apply/delete',
							data: {
								id: this.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									mask: true
								});
								setTimeout(() => {
									this.mp.navigateBack();
								}, 1000);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>